import React from 'react';
import { Button } from '@odin-labs/components';
import { MemoIcon, PenIcon, XMarkLargeIcon } from 'components/icons';

export function ScheduleWorkersTableActionsCell(props: {
  componentProps: {
    editAction: () => void;
    deleteAction: () => void;
    viewNotesAction: () => void;
  };
}): React.ReactNode {
  const {
    componentProps: { editAction, deleteAction, viewNotesAction },
  } = props;

  return (
    <div className="odin-flex odin-justify-end odin-items-center odin-gap-2">
      {viewNotesAction && (
        <Button icon={MemoIcon} theme="nakedWhite" onClick={viewNotesAction} />
      )}
      {editAction && (
        <Button icon={PenIcon} theme="nakedWhite" onClick={editAction} />
      )}
      {deleteAction && (
        <Button
          icon={XMarkLargeIcon}
          theme="nakedWhite"
          onClick={deleteAction}
        />
      )}
    </div>
  );
}
